module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consignment/consignment.component.html
// module id = 1238
// module chunks = 0